export function getTokenFromClientKey(clientKey: string): string {
  if (!clientKey) throw new Error("The client key is missing.");

  if (clientKey.split(".").length !== 3) {
    throw new Error(
      "Invalid clientKey attribute in DuffelCardForm. It must be a valid JWT.",
    );
  }

  const payloadString = clientKey.split(".")[1];

  try {
    const payload = JSON.parse(atob(payloadString));
    return payload.token;
  } catch (error) {
    throw new Error(
      "Invalid clientKey attribute in DuffelCardForm. It was not possible to read the payload.",
    );
  }
}
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";